export enum DeveloperPhoneType {
  PRIVATE = "private",
  WORK = "work",
  HOME = "home",
  OTHER = 'other'
}

export enum DeveloperPhoneRole {
  OWNER = "owner",
  AGENT = "agent",
  ASSISTANT = "assistant",
  OTHER = "other",
}


export interface IHiddenPhonesItem {
  phone?: string;
  delete?: boolean;
  type: DeveloperPhoneType;
  id?: string;
  customId?: string | number;
}

export interface IHiddenPhones {
  id?: string;
  customId?: number | string;
  delete: boolean;
  contactName: string;
  role?: DeveloperPhoneRole;
  isSecret?: boolean;
  description: string;
  phones: IHiddenPhonesItem[];
  canEdit: boolean;
}